import { PermitFormBody } from "../contexts/interfaces";

export const countCompletedDemonstrations = (permit: PermitFormBody) => {
    let count = 0;

    if (
        permit.demonstrationAssessor1 !== "" &&
        permit.demonstrationAssessor1 !== null &&
        permit.demonstrationAssessor1Date !== undefined &&
        permit.demonstrationAssessor1Date !== null
    ) {
        count++;
    }
    if (
        permit.demonstrationAssessor2 !== "" &&
        permit.demonstrationAssessor2 !== null &&
        permit.demonstrationAssessor2Date !== undefined &&
        permit.demonstrationAssessor2Date !== null
    ) {
        count++;
    }
    if (
        permit.demonstrationAssessor3 !== "" &&
        permit.demonstrationAssessor3 !== null &&
        permit.demonstrationAssessor3Date !== undefined &&
        permit.demonstrationAssessor3Date !== null
    ) {
        count++;
    }

    return count;
};